// extracted by mini-css-extract-plugin
module.exports = {"horizontalRule":"HorizontalRule_horizontalRule__8SFoX"};